import { useContext } from 'react';

import Text from 'components/common/Text';
import { VoucherContext, UserContext } from 'components/signUpFunnel/Contexts';
import { HOME_CHEF, TEMPO } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';

const StandardOrTempoPlanHeader = ({ box, servings, weeklyMeals }) => {
  const { voucher } = useContext(VoucherContext);
  const { user } = useContext(UserContext);

  const hasSmsDiscount = user?.smsDiscount && box?.smsIncentivePromo;
  const hasPromoDiscount = box?.promoApplied;
  const isHomeChef = useBrand(HOME_CHEF);
  const isTempo = useBrand(TEMPO);

  const TempoPromoText = () => {
    return (
      <>
        {voucher?.formattedDiscountString
          ? `${voucher?.formattedDiscountString} off your first box`
          : `${weeklyMeals} MEALS DELIVERED WEEKLY`}
      </>
    );
  };

  let promoHeaderContent;
  if (hasPromoDiscount && hasSmsDiscount) {
    promoHeaderContent = `${box?.promo.displayedDiscount} + 5% SMS DISCOUNT`;
  } else if (hasPromoDiscount) {
    promoHeaderContent = `${box?.promo.displayedDiscount} this box ${box?.promo.maxDiscount ? `(up to ${box?.promo.maxDiscount})` : ''}`;
  } else if (hasSmsDiscount) {
    promoHeaderContent = '5% SMS DISCOUNT APPLIED';
  } else {
    promoHeaderContent = (
      <>
        {isHomeChef && `${servings} Servings X ${weeklyMeals} Recipes`}
        {isTempo && <TempoPromoText />}
      </>
    );
  }

  let subtotalContent;
  if (hasPromoDiscount) {
    subtotalContent = (
      <Text htmlElement="span">
        <Text htmlElement="span" className="mr-2" brandStylesOverrides="h2 text-primary">
          {box?.promo.subtotalFormatted}
        </Text>
        <Text htmlElement="span" className="font-medium text-charcoal-80 line-through">
          {box?.subtotalFormatted}
        </Text>
      </Text>
    );
  } else if (hasSmsDiscount) {
    subtotalContent = (
      <Text htmlElement="span">
        <Text htmlElement="span" className="mr-2" brandStylesOverrides="h2 text-primary">
          {box?.smsIncentivePromo.subtotalFormatted}
        </Text>
        <Text htmlElement="span" className="font-medium text-charcoal-90 line-through">
          {box?.subtotalFormatted}
        </Text>
      </Text>
    );
  } else {
    subtotalContent = <Text brandStylesOverrides="h2 text-primary">{box?.subtotalFormatted}</Text>;
  }

  return (
    <>
      <Text brandStylesOverrides="h7 text-secondary" className="m-0 uppercase">
        {promoHeaderContent}
      </Text>
      {subtotalContent}
    </>
  );
};

StandardOrTempoPlanHeader.propTypes = {
  box: PropTypes.shape({
    promoApplied: PropTypes.bool.isRequired,
    promo: PropTypes.shape({
      subtotalFormatted: PropTypes.string,
      subtotalCents: PropTypes.number,
      pricePerServingFormatted: PropTypes.string,
      displayedDiscount: PropTypes.string,
      maxDiscount: PropTypes.string,
    }),
    subtotalFormatted: PropTypes.string,
    pricePerServingFormatted: PropTypes.string,
    smsIncentivePromo: PropTypes.shape({
      subtotalCents: PropTypes.number,
      subtotalFormatted: PropTypes.string,
    }),
  }),
  servings: PropTypes.number.isRequired,
  weeklyMeals: PropTypes.number.isRequired,
};

export default StandardOrTempoPlanHeader;
